@if (is_admin && categories) {
  <ts-admin-override-banner
    [admin_override]="admin_override"
    [prevent_default]="admin_cart_items?.length ? true : false"
    (emit_cart_change)="confirmCartChange($event)"
    (emit_admin_override)="getAdminOverride($event)"
  />
}

<div
  class="container-md pb-4 pb-sm-0 p-md-0 pb-md-2"
  [tds-data-loader]="{
    key: 'accessories-list',
    as_overlay: loader_key ? false : true,
    delay: loader_key ? false : true
  }"
>
  @if (cart_updated && !admin_toggle_hide_alert) {
    <div class="row">
      <div class="col col-12">
        <span class="alert alert-warning d-block">
          {{ 'alert_accessory_removal' | translate }}
        </span>
      </div>
    </div>
  }

  @if (!show_no_results) {
    <div class="row">
      <div class="col col-3 d-none d-lg-block">
        <ts-filters-index [categories]="categories" [filters]="filters" />
      </div>
      <div class="col col-12 col-lg-9">
        <ng-container>
          <div class="row justify-content-between">
            <div class="{{ category_filter_sort_classes }}">
              <h4 class="mb-0 d-flex">
                <span class="d-none d-lg-inline mb-0 display-4">
                  {{ category_name ? category_name : ('category' | translate) }}
                </span>
                <div
                  ngbDropdown
                  class="d-inline-block d-lg-none pt-0 mobile-list-sort"
                  placement="bottom-left"
                >
                  <h4
                    ngbDropdownToggle
                    id="SwitchCategoryBtn"
                    class="mb-0 cursor-pointer display-4"
                  >
                    {{ category_name ? category_name : ('category' | translate) }}
                  </h4>
                  <div ngbDropdownMenu aria-labelledby="SwitchCategoryBtn">
                    <ts-asset-category-filter [categories]="categories" [is_mobile]="true" />
                  </div>
                </div>
                <span class="ms-2 text-secondary ms-2 result-count-label">
                  ({{ accessories.length }}
                  {{
                    accessories.length === 1
                      ? ('item_found' | translate)
                      : ('items_found' | translate)
                  }})
                </span>
              </h4>
              <span class="d-flex align-items-center mt-3 mt-md-0">
                <small class="fw-normal">{{ 'sort_by' | translate }}:</small>
                <div ngbDropdown class="d-inline-block mobile-list-sort" placement="bottom-right">
                  <button
                    ngbDropdownToggle
                    id="AccessorySortBtn"
                    class="btn btn-sm ms-2 fw-normal focus-visible outlined-btn mobile-list-sort__btn"
                    type="button"
                  >
                    {{ selected_sort_dropdown_value }}
                  </button>
                  <div ngbDropdownMenu aria-labelledby="AccessorySortBtn">
                    @for (sort_label of sort_options; track sort_label) {
                      <button
                        ngbDropdownItem
                        class="mobile-list-sort__item"
                        (click)="sortAccessoryList(sort_label)"
                      >
                        <small>{{ sort_label }}</small>
                      </button>
                    }
                  </div>
                </div>
                <span class="d-block d-lg-none ms-2 mobile-list-filter">
                  <button
                    class="btn btn-sm fw-normal outlined-btn mobile-list-filter__btn"
                    type="button"
                    (click)="openMobileFilters(filterModal)"
                  >
                    <span class="material-icons-outlined filter-icon">filter_alt</span>
                    <span class="fw-normal">{{ 'filter' | translate }}</span>
                    <span class="badge text-bg-primary ms-1">{{ filters_count }}</span>
                  </button>
                </span>
              </span>
            </div>
          </div>
          @if (filter_tokens?.length) {
            <div class="pt-3">
              <ts-filter-tokens [filter_tokens]="filter_tokens" />
            </div>
          }
        </ng-container>
        <div class="row row-cols-1 row-cols-sm-2 row-cols-xl-3 g-4 py-3 pb-sm-1 pb-md-0">
          @for (accessory of accessories; track accessory) {
            <div class="col">
              <div class="card h-100 accessory-card overflow-hidden">
                <div class="card-body">
                  @if (accessory.in_cart) {
                    <div class="position-absolute top-0 start-100 text-end currently-in-cart">
                      <span ngbTooltip="{{ 'selected_item' | translate }}" class="material-icons">
                        check_circle
                      </span>
                    </div>
                  }
                  <span class="d-flex center-content justify-content-center border-bottom bg-white">
                    <img
                      class="mt-1 img-fluid mb-3 accessory-card__img"
                      [src]="accessory.image_url"
                      [alt]="accessory.name"
                      (error)="generateAccessoryImage($event, accessory)"
                    />
                  </span>
                  @if (accessory?.admin) {
                    <ts-admin-override-badge class="position-absolute end-0" />
                  }
                  <span class="mt-3 fw-normal line-clamp-2 accessory-card__title">
                    {{ constructAccessoryTitle(accessory) }}
                  </span>
                  <span class="mt-3 d-flex justify-content-between">
                    <span
                      class="fw-medium accessory-card__price"
                      [ngClass]="{ 'pb-2': !sanitizedHTML(accessory?.description) }"
                    >
                      {{ accessory.cost_to_currency }}
                    </span>
                    @if (sanitizedHTML(accessory?.description)) {
                      <span class="lh-1">
                        <button
                          class="btn btn-link neutral-btn text-capitalize text-decoration-underline p-1 me-n1 focus-visible"
                          (click)="openDetailsModal(accessory)"
                        >
                          <small>{{ 'view_details' | translate }}</small>
                        </button>
                      </span>
                    }
                  </span>
                  @if (!accessory.in_cart) {
                    <span>
                      <button
                        class="btn btn-primary mt-3 w-100"
                        type="button"
                        [tds-data-loader]="{
                          key: 'accessory-add-to-cart',
                          color: 'light',
                          as_overlay: true
                        }"
                        (click)="addToCart(accessory)"
                      >
                        {{ 'add_to_cart' | translate }}
                      </button>
                    </span>
                  } @else {
                    <div class="row mt-3">
                      <div class="col">
                        <div
                          class="btn-group w-100 accessory-card__incrementer"
                          role="group"
                          aria-label="Basic checkbox toggle button group"
                        >
                          <button
                            class="{{ incrementer_classes }}"
                            type="button"
                            (click)="removeFromCart(accessory)"
                          >
                            @if (accessory.quantity === 1) {
                              <span class="material-icons"> delete </span>
                            } @else {
                              <span class="material-icons">remove</span>
                            }
                          </button>
                          <span
                            class="d-flex flex-wrap justify-content-center align-items-center fw-medium w-50 border-top border-bottom border-secondary"
                          >
                            {{ accessory.quantity }}
                          </span>
                          <button
                            class="{{ incrementer_classes }}"
                            type="button"
                            [disabled]="accessory.quantity === 6"
                            (click)="addToCart(accessory, true)"
                          >
                            <span class="material-icons">add</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="alert alert-warning" role="alert">
      {{ 'no_compatible_accessories' | translate }}
    </div>
  }
</div>

<ts-price-summary
  [button_status]="disable_continue_btn"
  [navigate_page]="navigate_on_continue"
  [shopping_cart]="shopping_cart"
  [shopping_items_price]="shopping_items_price"
  [skip_button]="[14].includes(order_type_id) ? false : skip_button"
  [is_display_one_time_cost]="
    [14].includes(order_type_id) && accessories.length === 0 ? false : true
  "
  [keep_plan]="shopping_cart.keep_plan ?? false"
  [refresh_summary]="refresh_summary.asObservable()"
  (updateCostSummary)="getShoppingCartData($event)"
/>

<ng-template #filterModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ 'filters' | translate }}</h4>
    <button
      class="btn-close"
      type="button"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body pt-0">
    <div class="row mb-3 border-bottom">
      <div class="col">
        @if (filter_tokens?.length) {
          <span class="d-inline-block mb-3">
            <ts-filter-tokens [filter_tokens]="filter_tokens" [is_mobile]="true" />
          </span>
        }
      </div>
    </div>

    <div class="row">
      <div class="col">
        <ts-filters-index [categories]="categories" [filters]="filters" [is_mobile]="true" />
      </div>
    </div>
  </div>

  <div class="modal-footer border-top-0 pt-0">
    <button
      class="btn btn-primary mobile-apply-filters"
      type="button"
      (click)="modal.dismiss('Cross click')"
    >
      {{ 'apply_filters' | translate }}
    </button>
  </div>
</ng-template>
